{
  "screens": [
    { "id": "project-albums", "title": "Альбомы проекта", "urlPattern": "^/projects/[^/]+/albums" },
    { "id": "project-faces", "title": "Лица", "urlPattern": "^/projects/[^/]+/faces" },
    { "id": "album-editor", "title": "Редактор альбома", "urlPattern": "^/editor/" },
    { "id": "cabinet", "title": "Кабинет", "urlPattern": "^/(?:projects|designs)(?:[?#]|$)" },
    { "id": "project-wizard", "title": "Создание проекта", "urlPattern": "^/(?:projects/new|onboarding)(?:[/?#]|$)" },
    { "id": "design-wizard", "title": "Загрузка шаблонов", "urlPattern": "^/(?:designs|partner/templates)/new(?:[/?#]|$)" },
    { "id": "project", "title": "Проект", "urlPattern": "^/(?:projects/(?!new(?:[/?#]|$))[^/?#]+/|editor/)" }
  ],
  "records": [
    {
      "id": "library-door",
      "screen": "cabinet",
      "onRequest": true,
      "coach": {
        "title": "Видео-обзоры функций",
        "body": "Полный список коротких уроков открывается этой кнопкой"
      },
      "video": { "enabled": false },
      "doneOn": "anchor-click"
    },
    {
      "id": "templates-upload",
      "screen": "cabinet",
      "coach": {
        "title": "Загрузите свои шаблоны",
        "body": "Загрузите свои шаблоны и верстайте альбомы в привычном вам и вашим клиентам дизайне."
      },
      "video": { "enabled": true },
      "doneOn": "manual"
    },
    {
      "id": "template-apply-students",
      "screen": "cabinet",
      "onRequest": true,
      "coach": {
        "title": "Применить и к альбомам учеников",
        "body": "Утверждённые альбомы останутся как есть. В остальных правки учеников не сохранятся."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "template-approved",
      "screen": "cabinet",
      "onRequest": true,
      "coach": {
        "title": "Шаблон одобрен",
        "body": "Создайте новый проект с этим шаблоном или примените его к готовому",
        "actions": [{ "label": "Понятно" }, { "label": "Создать проект", "primary": true }]
      },
      "video": { "enabled": false },
      "doneOn": "manual"
    },
    {
      "id": "templates-wizard",
      "screen": "design-wizard",
      "onRequest": true,
      "coach": {
        "title": "Загрузите PSD или INDD из папки одного шаблона — по ним соберём развороты альбома",
        "body": ""
      },
      "video": { "enabled": false },
      "doneOn": "manual"
    },
    {
      "id": "upload-modes",
      "screen": "project-wizard",
      "onRequest": true,
      "coach": {
        "title": "Выберите, как загрузить съёмку",
        "body": "По умолчанию портреты учеников, педагогов и остальные фото загружаются по отдельности. Так лица распознаются точнее. Но можно загрузить и все разом."
      },
      "video": { "enabled": true },
      "doneOn": "manual"
    },
    {
      "id": "name-sources",
      "screen": "project-wizard",
      "onRequest": true,
      "coach": {
        "title": "Откуда берём имена",
        "body": "Имена учеников возьмём из названий файлов или из таблицы"
      },
      "video": { "enabled": true },
      "doneOn": "manual"
    },
    {
      "id": "faces-organizer-link",
      "screen": "project-faces",
      "coach": {
        "title": "Отправьте ссылку организатору, чтобы она вписала имена",
        "body": "Организатор заполнит имена, и они автоматически появятся во всех альбомах."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "master-save",
      "screen": "album-editor",
      "coach": {
        "title": "Что такое эталонный альбом",
        "body": "Это образец, по которому соберём альбомы всех учеников."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "master-layout-owner",
      "screen": "album-editor",
      "coach": {
        "title": "Кто собирает макет: вы или ученик?",
        "body": "По умолчанию макет собирают ученики. Выберите «Вы», чтобы собрать макет самому."
      },
      "video": { "enabled": true },
      "doneOn": "manual"
    },
    {
      "id": "master-student-rights",
      "screen": "album-editor",
      "coach": {
        "title": "Решите, что сможет менять ученик",
        "body": "Только фото или фото и раскладку разворота.",
        "aside": true
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "album-editor-masks",
      "screen": "album-editor",
      "coach": {
        "title": "Маски для смены формы фото",
        "body": "Перетащите маску на фото, и рамка станет например круглой"
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "album-editor-text",
      "screen": "album-editor",
      "coach": {
        "title": "Двигайте и настраивайте текст в дизайнере",
        "body": "Откройте все настройки текста: шрифт, размер, начертание, изгиб по кривой"
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "album-editor-save",
      "screen": "album-editor",
      "coach": {
        "title": "Отправьте макет на утверждение",
        "body": "Сохраните и вернитесь к списку. Отправка на утверждение — в меню альбома."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "album-editor-retouch",
      "screen": "album-editor",
      "coach": {
        "title": "Загрузите отретушированные фото",
        "body": "Загрузите отретушированное фото и новая версия автоматически подставится во все альбомы."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "albums-master-edit",
      "screen": "project-albums",
      "coach": {
        "title": "Начните с эталонного альбома",
        "body": "Соберите макет один раз — по нему соберём альбомы всех учеников."
      },
      "video": { "enabled": true, "lesson": "master-save" },
      "doneOn": "anchor-click"
    },
    {
      "id": "albums-select-for-student",
      "screen": "project-albums",
      "coach": {
        "title": "Выберите фото за ученика",
        "body": "Пройдите отбор глазами ученика. Соберём альбом по эталонному альбому, дальше его можно редактировать."
      },
      "video": { "enabled": true, "lesson": "master-layout-owner" },
      "doneOn": "manual"
    },
    {
      "id": "albums-send-class-link",
      "screen": "project-albums",
      "after": "albums-master-edit",
      "coach": {
        "title": "Отправьте ссылку группе или организатору",
        "body": "Ученики сами отберут фото и соберут альбомы. Ссылку удобно отправить в чат класса."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "albums-students-pick",
      "screen": "project-albums",
      "onRequest": true,
      "coach": {
        "title": "Как ученики отбирают фото",
        "body": "Отправьте ссылку в чат класса. Каждый ученик выберет свои фото, и его альбом сгенерируется по эталону"
      },
      "video": { "enabled": true, "lesson": "albums-send-class-link" },
      "doneOn": "manual"
    },
    {
      "id": "albums-step-pick",
      "screen": "project-albums",
      "onRequest": true,
      "coach": {
        "title": "Как отобрать фото для альбомов",
        "body": "Выберите, как отобрать фото для альбомов"
      },
      "video": { "enabled": true, "lesson": "master-layout-owner" },
      "doneOn": "manual"
    },
    {
      "id": "albums-etalon-apply-menu",
      "screen": "project-albums",
      "onRequest": true,
      "coach": {
        "title": "Применить эталон к альбомам можно в меню «Действия»",
        "body": "",
        "actions": [{ "label": "ОК", "primary": true }]
      },
      "video": { "enabled": false },
      "doneOn": "anchor-click"
    },
    {
      "id": "albums-edit-album",
      "screen": "project-albums",
      "coach": {
        "title": "Откройте альбом и проверьте макет",
        "body": "Фото и шаблоны на разворотах можно поменять."
      },
      "video": { "enabled": true },
      "doneOn": "manual"
    },
    {
      "id": "albums-send-for-approval",
      "screen": "project-albums",
      "coach": {
        "title": "Отправьте альбом на утверждение",
        "body": "Ученик посмотрит макет, заменит фото и шаблоны, если это разрешено, и утвердит его."
      },
      "video": { "enabled": true, "lesson": "album-editor-save" },
      "doneOn": "manual"
    },
    {
      "id": "albums-bulk-approval",
      "screen": "project-albums",
      "coach": {
        "title": "Переведите на утверждение сразу несколько альбомов",
        "body": "Отметьте готовые альбомы и нажмите «Отправить на утверждение». Ученики увидят их в своих кабинетах."
      },
      "video": { "enabled": true, "lesson": "album-editor-save" },
      "doneOn": "anchor-click"
    },
    {
      "id": "albums-view-as-client",
      "screen": "project-albums",
      "coach": {
        "title": "Посмотрите на альбом глазами ученика",
        "body": "Увидите отбор и утверждение так, как их видит ученик."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "albums-download",
      "screen": "project-albums",
      "after": "albums-send-class-link",
      "coach": {
        "title": "Скачайте макеты для печати",
        "body": "Кнопка «Скачать» подготовит макеты для печати утверждённых альбомов."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    },
    {
      "id": "retouch-section",
      "screen": "project",
      "coach": {
        "title": "Загрузка отретушированных фото",
        "body": "Скачайте фото из альбомов учеников, отретушируйте и загрузите обратно. Новые версии автоматически подставятся во все альбомы."
      },
      "video": { "enabled": true },
      "doneOn": "anchor-click"
    }
  ]
}
